// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.object("LuckyTilesBoard", {
  id: __t.u64(),
  userId: __t.u64(),
  weekStart: __t.u64(),
  tileLayout: __t.string(),
  revealedTiles: __t.string(),
  freePicksUsedToday: __t.u32(),
  paidPicksToday: __t.u32(),
  lastPickDate: __t.u64(),
  streakDays: __t.u32(),
  createdAt: __t.u64(),
  totalSpins: __t.u64(),
});


